<template>
  <div class="deal-header" :class="{ 'deal-header-danger': is_danger }">
    <div class="deal-header-info">
      <feather-icon
        icon="BookmarkIcon"
        size="16"
        class="text-secondary mr-50 flex-shrink-0"
      />
      <span class="text-overflow" :class="{ 'deal-header-danger': is_danger}">{{ title }}</span>
    </div>
    <span class="deal-header-price" :class="{ 'deal-header-danger': is_danger}">${{ separatebycomma(decimalFixed(price)) }}</span>
  </div>
</template>

<script>
import { decimalFixed, separatebycomma } from '@/libs/utils/formats'

export default {
  name: 'dealHeaderChat',
  props: {
    title: {
      type: String,
      default: '',
    },
    price: {
      type: [String, Number],
      default: '',
    },
    is_danger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      decimalFixed,
      separatebycomma,
    }
  },
}
</script>

<style scoped lang="scss">
.deal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  background: #f5f5f5;
  border-bottom: 1px solid #ccccccb0;
  &.deal-header-danger {
    background: #f8d7da;
    border-color: #f5c6cb;
    
  }
  .deal-header-info {
    display: flex;
    align-items: center;
    min-width: 0;
    .deal-header-title {
      font-weight: 600;
      font-size: 14px;

    }
  }
  .deal-header-price {
    font-weight: 700;
    font-size: 15px;
    color: #0096fe;
    white-space: nowrap;
  }
  .deal-header-danger {
    color: #721c24;
  }   
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
